/** Application root: data/query providers, the browser router and the authenticated app. */
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { BrowserRouter } from 'react-router';
import { AppRoot } from './AppRoot.js';
import { createQueryClient } from './lib/queries.js';

export function AppProviders({ client, children }: { client?: QueryClient; children: ReactNode }) {
  const [queryClient] = useState(() => client ?? createQueryClient());
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

export function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <AppRoot />
      </BrowserRouter>
    </AppProviders>
  );
}
